const IDENTITY_TYPES = {
    USER: 'user',
    COMPANY: 'company',
    WORKSPACE: 'workspace'
};

module.exports = { IDENTITY_TYPES };